import { createSignal } from "solid-js"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"
import { DraftMove } from "../../lib/core/draft_move/DraftMove.type"
import { isPlainObjDeeplyEqual } from "../../lib/isPlainObjDeeplyEqual"

export const useDraftMoveSignal = createSharedCachedFactory((
    // engine: Engine
) => {

    // eslint-disable-next-line solid/reactivity
    const signal = createSignal<DraftMove | null>(null, {
        equals: isPlainObjDeeplyEqual,
    })

    return signal
})
